// extracted by mini-css-extract-plugin
export default {"error":"input_error__V3w-f","input":"input_input__2W8SY","dark":"input_dark__m1kml","light":"input_light__K-L9v","section":"input_section__hQ7J8"};